import styled from "styled-components";
import { useTranslate } from "@tolgee/react";

const WarningConfirmationModal = ({
  open,
  icon,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslate();

  if (!open) {
    return null;
  }

  return (
    <ModalOverlay onClick={onCancel}>
      <ModalCard onClick={(e) => e.stopPropagation()}>
        {icon && <ModalIcon>{icon}</ModalIcon>}
        <ModalTitle>{title}</ModalTitle>
        <ModalMessage>{message}</ModalMessage>
        <ButtonRow>
          <CancelButton onClick={onCancel}>
            {cancelLabel || t("general.cancel")}
          </CancelButton>
          <ConfirmButton onClick={onConfirm} autoFocus>
            {confirmLabel}
          </ConfirmButton>
        </ButtonRow>
      </ModalCard>
    </ModalOverlay>
  );
};

export default WarningConfirmationModal;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px;
  max-width: 380px;
  width: 100%;
  background: ${({ theme }) => theme.menu.background};
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  border-radius: 16px;
  text-align: center;
`;

const ModalIcon = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: rgba(239, 68, 68, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ef4444;
  margin-bottom: 4px;
`;

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  margin: 0;
`;

const ModalMessage = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  margin: 0;
  line-height: 1.6;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 12px;
  width: 100%;
`;

const CancelButton = styled.button`
  flex: 1;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  background: transparent;
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.sidebar.borderColor};
  }
`;

const ConfirmButton = styled.button`
  flex: 1;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  background: #ef4444;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;
